import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.75 3.98171H13.9062V3.11585C13.9062 2.98095 13.7945 2.87195 13.6562 2.87195H11.1953L10.2789 2.01677C10.2672 2.00612 10.2519 2.00013 10.2359 2H8.25C8.11172 2 8 2.10899 8 2.2439V6.7561C8 6.89101 8.11172 7 8.25 7H13.7031C13.8047 7 13.8969 6.93979 13.9352 6.84756L14.982 4.31707C14.9938 4.28811 15 4.25686 15 4.22561C15 4.0907 14.8883 3.98171 14.75 3.98171ZM13.3438 3.98171H9.35938C9.25781 3.98171 9.16562 4.04192 9.12734 4.13415L8.5625 5.5V2.54878H10.0352L10.9695 3.42073H13.3438V3.98171Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.75 9.98171H13.9062V9.11585C13.9062 8.98095 13.7945 8.87195 13.6562 8.87195H11.1953L10.2789 8.01677C10.2672 8.00612 10.2519 8.00013 10.2359 8H8.25C8.11172 8 8 8.10899 8 8.2439V12.7561C8 12.891 8.11172 13 8.25 13H13.7031C13.8047 13 13.8969 12.9398 13.9352 12.8476L14.982 10.3171C14.9938 10.2881 15 10.2569 15 10.2256C15 10.0907 14.8883 9.98171 14.75 9.98171ZM13.3438 9.98171H9.35938C9.25781 9.98171 9.16562 10.0419 9.12734 10.1341L8.5625 11.5V8.54878H10.0352L10.9695 9.42073H13.3438V9.98171Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 2V11H6",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 5L6 5",
			stroke: "currentColor"
		})
	]
});
export default SvgSubFolder;
